import * as tslib_1 from "tslib";
import { DefaultMaterialManager } from "@awayjs/graphics";
import { ShaderChunkBase } from "./ShaderChunkBase";
/**
 * EffectAlphaMaskChunk allows the use of an additional texture to specify the alpha value of the material. When used
 * with the secondary uv set, it allows for a tiled main texture with independently varying alpha (useful for water
 * etc).
 */
var EffectAlphaMaskChunk = (function (_super) {
    tslib_1.__extends(EffectAlphaMaskChunk, _super);
    /**
     * Creates a new EffectAlphaMaskChunk object.
     */
    function EffectAlphaMaskChunk(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    /**
     * @inheritDoc
     */
    EffectAlphaMaskChunk.prototype._initVO = function (chunkVO) {
        this._alphaMask = this._shader.getAbstraction(this._method.texture || DefaultMaterialManager.getDefaultTexture());
        if (this._method.useSecondaryUV)
            this._shader.secondaryUVDependencies++;
        else
            this._shader.uvDependencies++;
    };
    /**
     * @inheritDoc
     */
    EffectAlphaMaskChunk.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var temp = registerCache.getFreeFragmentVectorTemp();
        return this._alphaMask._getFragmentCode(temp, registerCache, sharedRegisters, this._method.useSecondaryUV ? sharedRegisters.secondaryUVVarying : sharedRegisters.uvVarying) +
            "mul " + targetReg + ", " + targetReg + ", " + temp + ".x\n";
    };
    /**
     * @inheritDoc
     */
    EffectAlphaMaskChunk.prototype._activate = function () {
        _super.prototype._activate.call(this);
        this._alphaMask.activate();
    };
    EffectAlphaMaskChunk.prototype._setRenderState = function (renderable, projection) {
        this._alphaMask._setRenderState(renderable);
    };
    return EffectAlphaMaskChunk;
}(ShaderChunkBase));
export { EffectAlphaMaskChunk };



// WEBPACK FOOTER //
// ../dist/lib/chunks/EffectAlphaMaskChunk.js